export default __webpack_public_path__ + "static/media/order.cabf52a9.svg";